import { lazy } from 'react';

const RELOADED_AT = 'chunk-reloaded-at';

/**
 * React.lazy for a separately built chunk, plus `preload()` to fetch it ahead of time.
 *
 * After a deploy the chunk a long-open tab knows about no longer exists, so loading it
 * fails; reload once to pick up the new build instead of showing a broken page.
 */
export default function lazyWithReload(load) {
  const Component = lazy(() =>
    load().catch((error) => {
      let last = 0;
      try {
        last = Number(sessionStorage.getItem(RELOADED_AT)) || 0;
      } catch {
        // storage unavailable: fall through to a single reload
      }
      if (Date.now() - last > 10000) {
        try {
          sessionStorage.setItem(RELOADED_AT, String(Date.now()));
        } catch {
          // storage unavailable
        }
        window.location.reload();
        return new Promise(() => {}); // keep the fallback up until the reload happens
      }
      throw error;
    })
  );
  Component.preload = () => load().catch(() => {});
  return Component;
}
